/* Sticky add-to-cart bar. Shows when the main ATC scrolls out of view. Own variant
   selects + /cart/add.js, two-way synced with the main form's variant radios. */
(function () {
  var bar = document.querySelector('[data-hp-satc]');
  if (!bar) return;
  var mainAtc = document.querySelector('[data-add-to-cart]');

  var variants = [];
  try { variants = JSON.parse(bar.querySelector('[data-hp-satc-variants]').textContent); } catch (e) {}
  var selects = Array.prototype.slice.call(bar.querySelectorAll('[data-hp-satc-option]'));
  var priceEl = bar.querySelector('[data-hp-satc-price]');
  var atc = bar.querySelector('[data-hp-satc-atc]');
  var atcText = bar.querySelector('[data-hp-satc-atc-text]');
  var optionNames = selects.map(function (s) { return s.getAttribute('data-option-name'); });
  var singleVariant = selects.length === 0;

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/(["\\])/g, '\\$1'); }
  function currentSelection() { return selects.map(function (s) { return s.value || null; }); }
  function matchVariant(sel) {
    if (sel.indexOf(null) !== -1) return null;
    return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) || null;
  }
  function setBuy(v, soldout) {
    atc.classList.remove('is-added');
    if (v) { atc.disabled = false; atc.setAttribute('data-variant-id', v.id); atcText.textContent = 'Add to Cart'; }
    else { atc.disabled = true; atc.removeAttribute('data-variant-id'); atcText.textContent = soldout ? 'Sold Out' : atcText.textContent; }
  }
  function render() {
    if (singleVariant) { var only = variants[0]; setBuy(only && only.available ? only : null, only && !only.available); return; }
    var sel = currentSelection();
    var v = matchVariant(sel);
    if (v) {
      setBuy(v.available ? v : null, !v.available);
      if (v.available && priceEl) priceEl.textContent = money(v.price);
    } else {
      var firstUnset = sel.indexOf(null);
      atc.disabled = true; atc.classList.remove('is-added');
      atcText.textContent = firstUnset > -1 ? ('Select ' + optionNames[firstUnset]) : 'Unavailable';
    }
  }

  // sticky select -> sync to the main form radios, then re-render.
  // Radios sit OUTSIDE the <form> (associated via the form= attribute), so query
  // the document, not the form.
  selects.forEach(function (s) {
    s.addEventListener('change', function () {
      var radio = document.querySelector('input[data-variant-input][name="' + cssEsc(s.getAttribute('data-option-name')) + '"][value="' + cssEsc(s.value) + '"]');
      if (radio && !radio.checked) radio.click();
      render();
    });
  });

  // main form radio change -> reflect in the sticky selects (document-level, since
  // the radios don't bubble to the form element).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('input[data-variant-input]')) return;
    var sel = selects.filter(function (s) { return s.getAttribute('data-option-name') === input.name; })[0];
    if (sel && sel.value !== input.value) { sel.value = input.value; render(); }
  });

  // add to cart
  atc.addEventListener('click', function () {
    var id = atc.getAttribute('data-variant-id');
    if (!id || atc.disabled) return;
    atc.disabled = true; atcText.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        atc.classList.add('is-added'); atcText.textContent = 'Added ✓';
        updateCartCount();
        setTimeout(openCartDrawer, 400);
      }).catch(function () { atc.disabled = false; atcText.textContent = 'Add to Cart'; });
  });

  // show when the main ATC has scrolled above the viewport (i.e. past it)
  if (mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var pastIt = !en.isIntersecting && en.boundingClientRect.top < 0;
        if (pastIt) { bar.hidden = false; requestAnimationFrame(function () { bar.classList.add('is-visible'); }); }
        else { bar.classList.remove('is-visible'); }
      });
    }, { threshold: 0 }).observe(mainAtc);
  }

  function updateCartCount() {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-link__bubble, [data-cart-count]').forEach(function (n) {
        var t = n.querySelector('span') || n; t.textContent = c.item_count; n.classList.add('cart-link__bubble--visible');
      });
    }).catch(function () {});
  }
  function openCartDrawer() {
    var t = document.querySelector('.js-drawer-open-cart, [data-drawer-toggle="cart"]');
    if (t) t.click();
  }

  render();
})();
